/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { DashboardBackgroundScripts } from './ui/dashboard/index.tsx';

export const dashboardBackgroundScriptsLayout: Layout = createLayout({
	globalComponents: [DashboardBackgroundScripts],
});
